// extracted by mini-css-extract-plugin
export default {"wrapper":"raceArea_wrapper__Azh4x","infoWrapper":"raceArea_infoWrapper__fZwzP","title":"raceArea_title__9pseE","pageNumberTitle":"raceArea_pageNumberTitle__-IBGZ"};